import { invoke } from './invokeRequest';

export const checkSeverUptime = () => {
  return invoke('/uptime-robot');
};
